export default __webpack_public_path__ + "static/media/akin.5e50c75d.jpg";